@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Task Exception"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="disableSave">
    <div class="ws-flex-container-vertical ws-stretch">
        @if (options.length) {
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label>Action:</label>
                @for (option of options; track option) {
                    <div class="ws-flex-container-vertical">
                        <div class="exception-option ws-flex-auto ws-vertical-align-middle">
                            <label [for]="'option' + option.action + option.taskId"
                                   class="ws-font-weight-normal"
                                   helpTooltip
                                   [tooltipText]="option.title"
                                   position="bottom">
                                <input [id]="'option' + option.action + option.taskId"
                                       type="radio"
                                       name="exceptionOptions"
                                       [value]="option"
                                       [(ngModel)]="selectedOption"
                                       (ngModelChange)="selectedOptionChanged($event)"
                                       [disabled]="!option.isAuthorized"/>
                                {{ option.title }}
                            </label>
                        </div>
                        <div class="exception-user-team ws-flex-auto">
                            @if (option === selectedOption && option.action !== TaskProcessingActions.SkipTask) {
                                <div class="input-group">
                                    <input name="userTeam"
                                           type="text"
                                           placeholder="Assign to..."
                                           class="form-control"
                                           autocomplete="off"
                                           [(ngModel)]="userTeamFilter"
                                           container="return-task-exception-modal"
                                           [wsTypeahead]="userTeams$"
                                           [typeaheadWaitMs]="750"
                                           typeaheadOptionField="displayName"
                                           [typeaheadOptionsLimit]="50"
                                           [typeaheadScrollable]="true"
                                           [typeaheadMinLength]="1"
                                           (blur)="onUserTeamBlur()"
                                           (typeaheadOnSelect)="onUserTeamSelected($event)"
                                           (typeaheadLoading)="onUserTeamsLoadingChange($event)"/>
                                    <span class="input-group-text"
                                          [style.visibility]="userTeamsLoading ? 'visible' : 'hidden'">
                                        <ws-ace-loader [inline]="true"></ws-ace-loader>
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                }
                <label>Comment:</label>
                <textarea ref-textarea [(ngModel)]="comment" rows="4"></textarea>
            </div>
        }

        @if (!options.length) {
            <div class="ws-flex-container-vertical ws-flex-auto">
                No options available
            </div>
        }
    </div>
</ws-modal-wrapper>
